import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Row, Col } from 'reactstrap'

import { GeneralJobCard } from 'features/job/components/Jobs/Cards'

export const JobsGrid = ({ items, ...props }) => {
  const { t } = useTranslation()

  return (
    <>
      {items.map((item, i) => (
        <Row key={i}>
          <Col>
            <GeneralJobCard data={item} highlight={item.top} {...props} />
          </Col>
        </Row>
      ))}
    </>
  )
}

JobsGrid.propTypes = {
  items: PropTypes.array,
}
